module.exports = __webpack_public_path__ + "img/captainTroop.263bea74.png";